import React from 'react'
import Documents from 'components/Documents'
import PropTypes from 'prop-types'
import Loading from 'components/Loading'
import FeatureGuard from '../../components/FeatureToggle/FeatureGuard'

class Reports extends React.Component {
  static propTypes = {
    getReports: PropTypes.func.isRequired,
    reports: PropTypes.object.isRequired,
  }

  getReports = () => {
    this.props.getReports('error')
  }
  render() {
    const { currentUser, dispatch, reports } = this.props

    if (reports.isFetching) {
      return (<Loading pageLoading />)
    }

    const reportsArr = (currentUser.IsAdmin && this.props.location.pathname.indexOf('admin/') > -1) ? reports.reports.filter((report) => { return (report.IsAdmin === true) }) : reports.reports.filter((report) => { return (report.IsAdmin === false) })
    const showHeader = !!((currentUser.IsAdmin && this.props.location.pathname.indexOf('admin/') > -1))
    return (
      <FeatureGuard featureName="Reports" user={currentUser}>
        <div>
          {(showHeader ? <div style={{ fontSize: '20px', marginBottom: '-20px' }}>Reports</div> : '')}
          <Documents dispatch={dispatch} documentsArray={reportsArr} isLink isPdf={false} noRecordText="No report found" openInNewTab="_self" title="Report name" />
        </div >
      </FeatureGuard>
    )
  }
}

export default Reports



// WEBPACK FOOTER //
// ./src/views/Reports/Reports.js